"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScreamOfXiraAbilityHandler = exports.ScreamOfXiraActorAbilityFactory = exports.ScreamOfXiraAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const __1 = require("../..");
const Random_1 = require("../../utils/Random");
const Duration_1 = require("../../core/Duration");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class ScreamOfXiraAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ScreamOfXira;
        this.__typeName = "ScreamOfXira";
    }
}
exports.ScreamOfXiraAbilityArgs = ScreamOfXiraAbilityArgs;
let ScreamOfXiraActorAbilityFactory = class ScreamOfXiraActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ScreamOfXira", "AllEnemies", 2);
    }
};
ScreamOfXiraActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ScreamOfXira")
], ScreamOfXiraActorAbilityFactory);
exports.ScreamOfXiraActorAbilityFactory = ScreamOfXiraActorAbilityFactory;
let ScreamOfXiraAbilityHandler = class ScreamOfXiraAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const enemies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        container.applyMultiAttack({
            sequence,
            attackerId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            onDamage: (sequence, { targetId }) => sequence.push(new __1.InstantVfxStepArgs(new __1.ActorVfxLocationSelector(targetId, "chest"), "BloodyClaws")),
            targets: enemies.map((targetId, i) => ({
                targetId,
                jitter: (0, Random_1.random)(25, 75),
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Death", 90)
                ],
                effects: [
                    {
                        targetId,
                        duration: Duration_1.Duration.Turns(1),
                        effect: new __1.DisableAbilityEffectArgs((0, Random_1.randomElement)(container.getEquippedAbilitySlots(targetId)
                            .filter(slot => { var _a; return !(0, __1.hasValue)(__1.PassiveAbility, AbilityType_1.AbilityType[(_a = container.getAbilityInSlot(targetId, slot)) === null || _a === void 0 ? void 0 : _a.abilityType]); })
                            .filter(slot => !container.getAbilityInSlot(targetId, slot).disabled)))
                    }
                ]
            }))
        });
    }
};
ScreamOfXiraAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ScreamOfXira)
], ScreamOfXiraAbilityHandler);
exports.ScreamOfXiraAbilityHandler = ScreamOfXiraAbilityHandler;
